/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Competitive_5_DetailInputs */

const en_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reached the final stage in 1979`)
};

const es_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Llegó a la fase final en 1979`)
};

const de_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreichte 1979 die Finalrunde`)
};

const zh_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1979 年进入最终阶段`)
};

const ar_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وصل إلى المرحلة النهائية عام 1979`)
};

const fr_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A atteint la phase finale en 1979`)
};

const vi_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lọt vào vòng cuối năm 1979`)
};

const sw_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alifikia hatua ya mwisho mwaka 1979`)
};

const th_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผ่านเข้าสู่รอบสุดท้ายในปี 1979`)
};

const bs_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stigao do završne faze 1979.`)
};

const ja_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1979年に最終ステージまで進出`)
};

const ko_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1979년 최종 단계 진출`)
};

const pt_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chegou à fase final em 1979`)
};

const it_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ha raggiunto la fase finale nel 1979`)
};

const sv_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nådde slutsteget 1979`)
};

const nl_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereikte in 1979 de finalefase`)
};

const da_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nåede finalerunden i 1979`)
};

const nb_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nådde finalerunden i 1979`)
};

const fi_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pääsi loppuvaiheeseen vuonna 1979`)
};

const pl_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dotarł do finałowego etapu w 1979 r.`)
};

const ru_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Достиг финальной стадии в 1979 году`)
};

const tr_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1979'da final aşamasına ulaştı`)
};

const hi_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1979 में अंतिम चरण तक पहुँचे`)
};

const id_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mencapai tahap akhir pada tahun 1979`)
};

const ms_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mara ke peringkat akhir pada tahun 1979`)
};

const cs_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V roce 1979 dosáhl závěrečné etapy`)
};

const el_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Έφτασε στο τελικό στάδιο το 1979`)
};

const he_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הגיע לשלב האחרון בשנת 1979`)
};

const af_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het in 1979 die finale ronde bereik`)
};

const hu_about_content_competitive_5_detail = /** @type {(inputs: About_Content_Competitive_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1979-ben eljutott a döntő szakaszig`)
};

/**
* | output |
* | --- |
* | "Reached the final stage in 1979" |
*
* @param {About_Content_Competitive_5_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_competitive_5_detail = /** @type {((inputs?: About_Content_Competitive_5_DetailInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Competitive_5_DetailInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_competitive_5_detail(inputs)
	if (locale === "de") return de_about_content_competitive_5_detail(inputs)
	if (locale === "zh") return zh_about_content_competitive_5_detail(inputs)
	if (locale === "ar") return ar_about_content_competitive_5_detail(inputs)
	if (locale === "fr") return fr_about_content_competitive_5_detail(inputs)
	if (locale === "vi") return vi_about_content_competitive_5_detail(inputs)
	if (locale === "sw") return sw_about_content_competitive_5_detail(inputs)
	if (locale === "th") return th_about_content_competitive_5_detail(inputs)
	if (locale === "bs") return bs_about_content_competitive_5_detail(inputs)
	if (locale === "ja") return ja_about_content_competitive_5_detail(inputs)
	if (locale === "ko") return ko_about_content_competitive_5_detail(inputs)
	if (locale === "pt") return pt_about_content_competitive_5_detail(inputs)
	if (locale === "it") return it_about_content_competitive_5_detail(inputs)
	if (locale === "sv") return sv_about_content_competitive_5_detail(inputs)
	if (locale === "nl") return nl_about_content_competitive_5_detail(inputs)
	if (locale === "da") return da_about_content_competitive_5_detail(inputs)
	if (locale === "nb") return nb_about_content_competitive_5_detail(inputs)
	if (locale === "fi") return fi_about_content_competitive_5_detail(inputs)
	if (locale === "pl") return pl_about_content_competitive_5_detail(inputs)
	if (locale === "ru") return ru_about_content_competitive_5_detail(inputs)
	if (locale === "tr") return tr_about_content_competitive_5_detail(inputs)
	if (locale === "hi") return hi_about_content_competitive_5_detail(inputs)
	if (locale === "id") return id_about_content_competitive_5_detail(inputs)
	if (locale === "ms") return ms_about_content_competitive_5_detail(inputs)
	if (locale === "cs") return cs_about_content_competitive_5_detail(inputs)
	if (locale === "el") return el_about_content_competitive_5_detail(inputs)
	if (locale === "he") return he_about_content_competitive_5_detail(inputs)
	if (locale === "af") return af_about_content_competitive_5_detail(inputs)
	if (locale === "hu") return hu_about_content_competitive_5_detail(inputs)
	return en_about_content_competitive_5_detail(inputs)
});